<template>
    <div>
      <button class="btn" @click="clickHandler(buttonText[step-1])" id="blueBtn--p">{{ buttonText[step-1] }}<i class="fas fa-chevron-right" id="iconRight" v-if="seenIconRight"></i><i class="fas fa-chevron-down" v-if="seenIconDown"></i></button>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'blueButton',
  data () { 
    return {
      seenIconRight: true,
      seenIconDown: false
    }
  },
  props: [
    'buttonText',
    'step',
    'items'
  ],
  mounted () {
    this.iconChange()
  },
  methods: {
    clickHandler: function(text){
      if (text !== 'もっとみる') {
        this.$emit('click')
      } else {
        this.$emit('readMore')
      }
    },
    iconChange: function () {
      if (this.step === 3) {
        this.seenIconRight = false
        this.seenIconDown = true
      } else {
        this.seenIconRight = true
        this.seenIconDown = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  text-align: center;
  display:block;
  margin: 30px auto 0;
  padding:15px 0;
  background-color: #831f17;
  color:#fff;
  width:80%;
  position: relative;
  font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN",HGS明朝E,メイリオ,Meiryo,serif;
    &:hover {
        opacity:0.7;
        cursor: pointer;
    }
}
i {
  color: #fff;
  text-align: right;
  position: absolute;
  right: 30px;
  top: 50%;
  margin-top: -.5em;
}

</style>
